// "Which geos are in the top 10 by clicks AND regs AND deps at once" — the
// question the team used to answer by copying three top-10 lists into a sheet.

export type TopMetric = 'clicks' | 'regs' | 'deps';

export const TOP_METRICS: { key: TopMetric; label: string }[] = [
  { key: 'clicks', label: 'Clicks' },
  { key: 'regs', label: 'Regs' },
  { key: 'deps', label: 'Deps' },
];

interface RowLike { key: string; clicks: number; regs: number; deps: number }

/**
 * Keys of the rows that are in the top `n` for every picked metric. A row
 * with zero of a metric is never "top" for it, so an intersection with Deps
 * only keeps geos that actually deposited. `exclude` drops aggregate rows
 * ("other"). No metric picked → null (no filter).
 */
export function topIntersection<T extends RowLike>(
  rows: T[], metrics: TopMetric[], n = 10, exclude: string[] = [],
): Set<string> | null {
  if (metrics.length === 0) return null;
  const pool = rows.filter((r) => !exclude.includes(r.key));
  const tops = metrics.map((m) => new Set(
    pool.filter((r) => r[m] > 0)
      .sort((a, b) => b[m] - a[m] || a.key.localeCompare(b.key))
      .slice(0, n)
      .map((r) => r.key),
  ));
  const [first, ...rest] = tops;
  return new Set([...first].filter((k) => rest.every((t) => t.has(k))));
}
